import { Roda3D } from '../../caminhaoTanque/Roda3D'
import {
  BarraLuzes3D,
  ChevronTraseiro3D,
  Persiana3D,
} from './DetalhesViatura3D'
import { PecaDetalhe3D as Peca } from './PecaDetalhe3D'

export type TipoViaturaEspecial = 'viaturaHazmat' | 'viaturaAbt'
const VIDRO = '#294451'
const CHASSI = '#26323b'

export function FiguraViaturaEspecial3D({
  tipo,
}: {
  tipo: TipoViaturaEspecial
}) {
  const hazmat = tipo === 'viaturaHazmat'
  const cor = '#bc4742'
  return (
    <group name={tipo}>
      <Peca
        posicao={[0, 0.63, 0]}
        tamanho={[2.28, 0.26, 5.85]}
        cor={CHASSI}
        raio={0.06}
      />
      <Peca
        posicao={[0, 1.64, 2.01]}
        tamanho={[2.42, 1.88, 1.95]}
        cor={cor}
        metal={0.25}
        raio={0.12}
      />
      <Peca
        posicao={[0, 2.62, 2.01]}
        tamanho={[2.42, 0.14, 1.97]}
        cor="#e5e9e5"
        raio={0.055}
      />
      <Peca
        posicao={[0, 1.63, -1.02]}
        tamanho={[2.5, 1.94, 3.96]}
        cor={cor}
        metal={0.2}
        raio={0.085}
      />
      <Peca
        posicao={[0, 2.63, -1.02]}
        tamanho={[2.42, 0.1, 3.89]}
        cor="#7d8e95"
        metal={0.55}
        raio={0.025}
      />
      <Peca
        posicao={[0, 2.11, 3.006]}
        tamanho={[2.14, 0.75, 0.043]}
        cor={VIDRO}
        metal={0.4}
        rugosidade={0.13}
        raio={0.025}
      />
      <Peca
        posicao={[0, 1.5, 3.027]}
        tamanho={[1.42, 0.43, 0.08]}
        cor={CHASSI}
        raio={0.04}
      />
      {[1.35, 1.5, 1.65].map((y) => (
        <Peca
          key={y}
          posicao={[0, y, 3.074]}
          tamanho={[1.29, 0.035, 0.015]}
          cor="#8c9da4"
          metal={0.7}
          raio={0.006}
        />
      ))}
      <Peca
        posicao={[0, 0.82, 3.01]}
        tamanho={[2.54, 0.26, 0.27]}
        cor={CHASSI}
        metal={0.3}
        raio={0.05}
      />
      <Peca
        posicao={[0, 0.68, -3.04]}
        tamanho={[2.5, 0.15, 0.33]}
        cor="#7f9098"
        metal={0.65}
        raio={0.025}
      />
      <BarraLuzes3D y={2.76} z={2.03} />
      <ChevronTraseiro3D largura={2.24} altura={1.45} y={1.64} z={-3.006} />
      {[-1, 1].map((lado) => (
        <group key={lado}>
          <Peca
            posicao={[lado * 1.216, 2.11, 2.05]}
            tamanho={[0.03, 0.65, 1.36]}
            cor={VIDRO}
            raio={0.02}
            metal={0.4}
            rugosidade={0.13}
          />
          <Peca
            posicao={[lado * 1.23, 1.5, 2.07]}
            tamanho={[0.018, 0.02, 1.62]}
            cor="#753d36"
            raio={0.006}
          />
          <Peca
            posicao={[lado * 1.25, 1.66, 1.43]}
            tamanho={[0.055, 0.05, 0.2]}
            cor="#bac5ca"
            metal={0.65}
            raio={0.013}
          />
          <Peca
            posicao={[lado * 1.34, 2.1, 2.75]}
            tamanho={[0.28, 0.035, 0.04]}
            cor={CHASSI}
            raio={0.012}
          />
          <Peca
            posicao={[lado * 1.47, 2.06, 2.75]}
            tamanho={[0.1, 0.32, 0.2]}
            cor={CHASSI}
            raio={0.025}
          />
          <Peca
            posicao={[lado * 1.529, 2.06, 2.75]}
            tamanho={[0.015, 0.26, 0.14]}
            cor="#97b0bb"
            metal={0.85}
            rugosidade={0.1}
            raio={0.005}
          />
          <Peca
            posicao={[lado * 1.19, 0.51, 1.47]}
            tamanho={[0.38, 0.12, 0.64]}
            cor="#8c9ca3"
            metal={0.6}
            raio={0.022}
          />
          <Peca
            posicao={[lado * 0.91, 1.07, 3.055]}
            tamanho={[0.36, 0.25, 0.06]}
            cor="#f5edd7"
            rugosidade={0.15}
            raio={0.035}
            realce={{ emissive: '#f5edd7', emissiveIntensity: 0.3 }}
          />
          <Peca
            posicao={[lado * 0.46, 1.79, 3.044]}
            tamanho={[0.75, 0.018, 0.018]}
            cor={CHASSI}
            raio={0.005}
            rotacao={[0, 0, lado * 0.09]}
          />
          <Peca
            posicao={[lado * 1.27, 2.33, -1]}
            tamanho={[0.025, 0.09, 3.79]}
            cor="#eee7b3"
            raio={0.006}
          />
          <Peca
            posicao={[lado * 1.27, 0.86, -0.93]}
            tamanho={[0.025, 0.09, 3.74]}
            cor="#eee7b3"
            raio={0.006}
          />
          {[-2.31, -1.05, 0.21].map((z) => (
            <Persiana3D key={z} lado={lado} z={z} />
          ))}
          {[2.17, -2.03].map((z) => (
            <group key={z}>
              <Roda3D lado={lado * 1.08} z={z} raio={0.47} largura={0.34} />
              <mesh
                position={[lado * 1.253, 0.47, z]}
                rotation={[0, Math.PI / 2, 0]}
              >
                <torusGeometry args={[0.51, 0.055, 6, 18, Math.PI]} />
                <meshStandardMaterial color={CHASSI} roughness={0.7} />
              </mesh>
            </group>
          ))}
          <Peca
            posicao={[lado * 1.04, 0.96, -3.03]}
            tamanho={[0.2, 0.26, 0.05]}
            cor="#c83930"
            raio={0.025}
          />
        </group>
      ))}
      {hazmat ? (
        <group name="equipamentos-hazmat">
          <Peca
            posicao={[0, 2.84, -1.52]}
            tamanho={[1.57, 0.33, 1.68]}
            cor="#344652"
            raio={0.06}
          />
          {[-1, 1].map((lado) => (
            <Peca
              key={lado}
              posicao={[lado * 0.42, 3.025, -1.52]}
              tamanho={[0.06, 0.04, 1.63]}
              cor="#9dabb2"
              metal={0.6}
              raio={0.01}
            />
          ))}
          <Peca
            posicao={[0.68, 2.82, 0.3]}
            tamanho={[0.1, 0.35, 0.1]}
            cor="#b9c7cd"
            metal={0.7}
            raio={0.018}
          />
          <Peca
            posicao={[0.68, 3.2, 0.3]}
            tamanho={[0.035, 0.44, 0.035]}
            cor={CHASSI}
            raio={0.008}
          />
          {[-1, 1].map((lado) => (
            <group
              key={lado}
              position={[lado * 1.283, 1.56, -1.05]}
              rotation={[0, (lado * Math.PI) / 2, Math.PI / 4]}
            >
              <mesh>
                <boxGeometry args={[0.42, 0.42, 0.012]} />
                <meshStandardMaterial color="#f4d459" />
              </mesh>
              <Peca
                posicao={[0, 0, 0.018]}
                tamanho={[0.12, 0.12, 0.012]}
                cor="#27363d"
                raio={0.01}
              />
            </group>
          ))}
        </group>
      ) : (
        <group name="equipamentos-abt">
          {[-0.93, -0.37].map((x) => (
            <Peca
              key={x}
              posicao={[x, 2.77, -1.09]}
              tamanho={[0.06, 0.065, 3.47]}
              cor="#c4cdd0"
              metal={0.65}
              raio={0.01}
            />
          ))}
          {Array.from({ length: 10 }, (_, i) => (
            <Peca
              key={i}
              posicao={[-0.65, 2.77, -2.6 + i * 0.34]}
              tamanho={[0.62, 0.04, 0.055]}
              cor="#b6c1c7"
              metal={0.6}
              raio={0.008}
            />
          ))}
          <mesh position={[0.61, 2.83, 0.24]}>
            <cylinderGeometry args={[0.17, 0.21, 0.34, 12]} />
            <meshStandardMaterial color={cor} metalness={0.3} />
          </mesh>
          <Peca
            posicao={[0.61, 3.06, 0.4]}
            tamanho={[0.12, 0.12, 0.53]}
            cor="#a9b9c0"
            metal={0.75}
            raio={0.025}
            rotacao={[-0.35, 0, 0]}
          />
          <Peca
            posicao={[1.3, 1.51, -1.05]}
            tamanho={[0.04, 0.84, 0.95]}
            cor="#26363e"
            raio={0.02}
            metal={0.5}
          />
          {[-0.24, 0.24].map((z) => (
            <group key={z}>
              <mesh
                position={[1.333, 1.72, -1.05 + z]}
                rotation={[0, 0, Math.PI / 2]}
              >
                <cylinderGeometry args={[0.08, 0.08, 0.025, 12]} />
                <meshStandardMaterial color="#e3e7df" metalness={0.25} />
              </mesh>
              <Peca
                posicao={[1.354, 1.72, -1.05 + z]}
                tamanho={[0.006, 0.08, 0.009]}
                cor="#293841"
                raio={0.002}
                rotacao={[0.45, 0, 0]}
              />
              <mesh
                position={[1.355, 1.32, -1.05 + z]}
                rotation={[0, 0, Math.PI / 2]}
              >
                <cylinderGeometry args={[0.068, 0.068, 0.11, 12]} />
                <meshStandardMaterial
                  color="#b4bec1"
                  metalness={0.75}
                  roughness={0.3}
                />
              </mesh>
            </group>
          ))}
        </group>
      )}
    </group>
  )
}
